import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import Icon, { IconName } from '../icon'
import { useResponsive } from '../hooks'

type Props = {
  open: boolean
  autoHideDuration?: number
  children?: React.ReactNode
  onToggle?: (arg0: boolean) => void
  message: string
  position?: 'top' | 'bottom'
  closeButton?: boolean
  icon?: IconName
  className?: string
  iconClassName?: string
}

export const SnackBar = ({
  open = false,
  autoHideDuration,
  children,
  onToggle,
  message,
  position = 'bottom',
  closeButton,
  icon,
  className,
  iconClassName,
}: Props) => {
  const [fadeOut, setFadeOut] = useState(false)
  const [fadeIn, setFadeIn] = useState(false)
  const { isSmallScreen } = useResponsive()

  const handleClose = () => {
    setFadeOut(true)
    const timer = setTimeout(() => {
      setFadeOut(false)

      if (onToggle) {
        onToggle(false)
      }
    }, 300)
    return () => clearTimeout(timer)
  }

  const triggerFadeOut = () => {
    const timer = setTimeout(() => {
      if (onToggle) {
        onToggle(false)
      }
      setFadeOut(false)
    }, 300)
    return () => clearTimeout(timer)
  }

  useEffect(() => {
    if (open) {
      setFadeIn(true)
      if (autoHideDuration && autoHideDuration != 0) {
        const timer = setTimeout(() => {
          setFadeOut(true)
          setFadeIn(false)
          triggerFadeOut()
        }, autoHideDuration)
        return () => clearTimeout(timer)
      }
    }
  }, [open, autoHideDuration])

  return (
    <div>
      {children && <span>{children}</span>}
      {open && (
        <div
          className={classNames(
            `c-snackbar col-10 col-md-8`,
            className,
            {
              'u-py-8 u-px-16': !isSmallScreen,
              'u-py-0 u-px-16': isSmallScreen,
            },

            `${fadeIn ? `pull-animation--${position}` : ''} ${
              fadeOut ? `push-animation--${position}` : ''
            }`
          )}>
          {icon && <Icon className={iconClassName ?? 'i-24'} name={icon} />}
          <p
            className={classNames('u-px-12 u-py-16', {
              'u-fs-20': !isSmallScreen,
              'u-fs-16': isSmallScreen,
            })}>
            {message}
          </p>
          {closeButton && (
            <button
              className="u-border-0 u-pt-12 u-pr-0 u-pb-12 u-pl-0"
              onClick={() => handleClose()}>
              <Icon className="i-24 d-flex justify-content-end" name={'close'} />
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default SnackBar
